/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reporting period for time-based queries
 * @export
 * @interface ReportingPeriod
 */
export interface ReportingPeriod {
    /**
     * Period type (MINUTES, HOURS, DAYS, MONTHS, QUARTERS, ALL_TIME)
     * @type {string}
     * @memberof ReportingPeriod
     */
    type?: ReportingPeriodTypeEnum;
    /**
     * Number of units (e.g., 7 for 'Last 7 days')
     * @type {number}
     * @memberof ReportingPeriod
     */
    value?: number;
    /**
     * Display label (e.g., 'Last 7 days')
     * @type {string}
     * @memberof ReportingPeriod
     */
    label?: string;
    /**
     * Display label short format (e.g., '7d')
     * @type {string}
     * @memberof ReportingPeriod
     */
    shortLabel?: string;
}


/**
 * @export
 */
export const ReportingPeriodTypeEnum = {
    Minutes: 'MINUTES',
    Hours: 'HOURS',
    Days: 'DAYS',
    Months: 'MONTHS',
    Quarters: 'QUARTERS',
    AllTime: 'ALL_TIME'
} as const;
export type ReportingPeriodTypeEnum = typeof ReportingPeriodTypeEnum[keyof typeof ReportingPeriodTypeEnum];


/**
 * Check if a given object implements the ReportingPeriod interface.
 */
export function instanceOfReportingPeriod(value: object): value is ReportingPeriod {
    return true;
}

export function ReportingPeriodFromJSON(json: any): ReportingPeriod {
    return ReportingPeriodFromJSONTyped(json, false);
}

export function ReportingPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
        'shortLabel': json['shortLabel'] == null ? undefined : json['shortLabel'],
    };
}

export function ReportingPeriodToJSON(json: any): ReportingPeriod {
    return ReportingPeriodToJSONTyped(json, false);
}

export function ReportingPeriodToJSONTyped(value?: ReportingPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
        'label': value['label'],
        'shortLabel': value['shortLabel'],
    };
}

